
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZCode',
  props: {
    content: {
      type: String,
      required: true
    }
  }
})
